module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("morder.infoTitle")))]), _vm._v(" "), _c('div', {
    staticClass: "mline"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, _vm._l((_vm.userConfig), function(user, index) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "10px",
        "width": "400px",
        "float": "left"
      }
    }, [_c('label', {
      staticStyle: {
        "display": "inline-block",
        "width": "200px",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(user.cfgName) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(user.cfgValue != null && user.cfgValue.length > 15 ? user.cfgValue.substr(0, 15) + "..." : user.cfgValue))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "title",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("morder.signTitle")))])]), _vm._v(" "), _c('div', {
    staticClass: "mline"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "o_label"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("morder.signType")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.feeName))])]), _vm._v(" "), _c('div', {
    staticClass: "pay",
    class: {
      pay_mg_en: _vm.locale == 'en', pay_mg_ch: _vm.locale == 'ch'
    }
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.$t("morder.payType")) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.register.regPayway == '1' ? _vm.$t("pay.payOnline") : _vm.$t("pay.payOffline")))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t("morder.payStatus")) + ":")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.register.regFl == '0' || _vm.register.regFl == '1' ? _vm.$t("pay.nopay") : _vm.register.regFl == '2' ? _vm.$t("pay.payed") : _vm.register.regFl == '4' ? _vm.$t("pay.drawback") : _vm.register.regFl == '5' ? _vm.$t("pay.drawbacked") : ""))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t("morder.regMoneyTitle")) + ":")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.register.regMoney) + _vm._s(_vm.locale == 'en' ? "CNY" : "元"))])])])]), _vm._v(" "), _c('div', {
    staticClass: "title",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("morder.hotelTitle")))])]), _vm._v(" "), _c('div', {
    staticClass: "mline"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bookId == '' || _vm.bookId == null),
      expression: "bookId==''||bookId==null"
    }],
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "20px",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("morder.noHotel")))]), _vm._v(" "), _vm._l((_vm.hotel_books), function(hotelBook) {
    return _c('div', [_c('div', {
      staticClass: "o_label"
    }, [_c('label', [_vm._v(_vm._s(_vm.$t("morder.hotelName")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(hotelBook.hotel.hName))])]), _vm._v(" "), _c('div', {
      staticClass: "o_label"
    }, [_c('label', [_vm._v(_vm._s(_vm.$t("morder.roomType")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(hotelBook.room.rmName))]), _vm._v(" "), _c('label', {
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_vm._v(_vm._s(_vm.$t("hotel.inHotelTime")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm._f("formatDt")(hotelBook.bookStartDt)))]), _vm._v(" "), _c('label', {
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_vm._v(_vm._s(_vm.$t("hotel.outHotelTime")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm._f("formatDt")(hotelBook.bookEndDt)))])]), _vm._v(" "), _c('div', {
      staticClass: "o_label"
    }, [_c('label', [_vm._v(_vm._s(_vm.$t("hotel.days")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(hotelBook.bookDays) + _vm._s(_vm.$t("morder.night")))]), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (hotelBook.bookRoomieName != '' && hotelBook.bookRoomieName != null),
        expression: "hotelBook.bookRoomieName!=''&& hotelBook.bookRoomieName!=null"
      }],
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_vm._v(_vm._s(_vm.$t("hotel.togeName")) + ":")]), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (hotelBook.bookRoomieName != '' && hotelBook.bookRoomieName != null),
        expression: "hotelBook.bookRoomieName!='' && hotelBook.bookRoomieName!=null"
      }]
    }, [_vm._v(_vm._s(hotelBook.bookRoomieName))]), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (hotelBook.bookRoomiePhone != '' && hotelBook.bookRoomiePhone != null),
        expression: "hotelBook.bookRoomiePhone!=''&& hotelBook.bookRoomiePhone!=null"
      }],
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_vm._v(_vm._s(_vm.$t("hotel.togePhone")) + ":")]), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (hotelBook.bookRoomiePhone != '' && hotelBook.bookRoomiePhone != null),
        expression: "hotelBook.bookRoomiePhone!='' && hotelBook.bookRoomiePhone!=null"
      }]
    }, [_vm._v(_vm._s(hotelBook.bookRoomiePhone))])]), _vm._v(" "), _c('div', {
      staticClass: "pay",
      class: {
        pay_mg_en: _vm.locale == 'en', pay_mg_ch: _vm.locale == 'ch'
      }
    }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.$t("morder.payType")) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(hotelBook.bookPayway == '1' ? _vm.$t("pay.payOnline") : _vm.$t("pay.payOffline")))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t("morder.payStatus")) + ":")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(hotelBook.bookFl == '0' || hotelBook.bookFl == '1' ? _vm.$t("pay.nopay") : hotelBook.bookFl == '2' ? _vm.$t("pay.payed") : ""))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t("hotel.hotelMoney")) + ":")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(hotelBook.bookMoney) + _vm._s(_vm.locale == 'en' ? "CNY" : "元"))])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.regConfig.cfgInvoiceFl == '1' && _vm.locale == 'ch'),
      expression: "regConfig.cfgInvoiceFl=='1' && locale=='ch'"
    }],
    staticClass: "title",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("morder.invTitle")))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.regConfig.cfgInvoiceFl == '1' && _vm.locale == 'ch'),
      expression: "regConfig.cfgInvoiceFl=='1' && locale=='ch'"
    }],
    staticClass: "mline"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.register.regInvoiceType == '0'),
      expression: "register.regInvoiceType=='0'"
    }],
    staticStyle: {
      "margin-left": "30px",
      "margin-top": "20px",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("morder.noInvoice")))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.regConfig.cfgInvoiceFl == '1' && _vm.register.regInvoiceType != '0' && _vm.locale == 'ch'),
      expression: "regConfig.cfgInvoiceFl=='1' && register.regInvoiceType!='0' && locale=='ch'"
    }]
  }, [_c('div', {
    staticClass: "o_label"
  }, [_c('label', {
    class: {
      vtype_mg_en: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("morder.invoiceType")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvoiceType == '1' ? _vm.$t("invoice.invoiceType1") : _vm.$t("invoice.invoiceType2")))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.register.regInvoiceType == '1'),
      expression: "register.regInvoiceType=='1'"
    }],
    staticClass: "o_label"
  }, [_c('label', {
    class: {
      vtype1_mg_en: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invRegTitle")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvTitle))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.register.regInvoiceType == '2'),
      expression: "register.regInvoiceType=='2'"
    }],
    class: {
      vad_mg_en: _vm.locale == 'en'
    }
  }, [_c('div', {
    staticClass: "o_label"
  }, [_c('label', {
    class: {
      o_label_en: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddOrg")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvOrg))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-6px",
      "margin-top": "10px"
    }
  }, [_c('label', {
    class: {
      o_label_en2: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddTax")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvTax))])]), _vm._v(" "), _c('div', {
    staticClass: "o_label"
  }, [_c('label', {
    class: {
      o_label_en: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddAddr")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvAddr))])]), _vm._v(" "), _c('div', {
    staticClass: "o_label"
  }, [_c('label', {
    class: {
      o_label_en: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddTel")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvTel))])]), _vm._v(" "), _c('div', {
    staticClass: "o_label"
  }, [_c('label', {
    class: {
      o_label_en: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddBank")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvBank))])]), _vm._v(" "), _c('div', {
    staticClass: "o_label"
  }, [_c('label', {
    class: {
      o_label_en: _vm.locale == 'en'
    }
  }, [_vm._v(_vm._s(_vm.$t("invoice.invAddAcount")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvAccount))])])]), _vm._v(" "), (_vm.register.regInvoiceType != '0') ? _c('div', [_c('div', {
    class: {
      ch_mg_contact: _vm.locale == 'ch', en_mg_contact2: _vm.locale == 'en'
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("invoice.invGetName")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvoiceContact))])]), _vm._v(" "), _c('div', {
    class: {
      ch_mg_contact: _vm.locale == 'ch', en_mg_contact: _vm.locale == 'en'
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("invoice.invGetPhone")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvoicePhone))])]), _vm._v(" "), _c('div', {
    class: {
      ch_mg_contact2: _vm.locale == 'ch', en_mg_contact: _vm.locale == 'en'
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("invoice.invGetAddr")) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.register.regInvoiceAddr))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "30px 30px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.regConfig.cfgConfirmDesc)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "80px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.pre
    }
  }, [_vm._v(_vm._s(_vm.$t("btn.pre")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#F39800",
      "color": "#FFF"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v(_vm._s(_vm.$t("pay.payOrder")))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85618a5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/morder.vue
// module id = 817
// module chunks = 10